<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">Amateur Armies</h1>
<p class="subtitle">Militias and Volunteers in War and Peace, 1797-1961</p>
<p class="author">Stephen M. Cullen</p>
<div class="img_container"><img alt="images" src="images/pub.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?76e2fcff